module.exports = __webpack_public_path__ + "img/varoszoba_1.0a85e097.jpg";